import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from './CandleMagnitudeTacticPanel.module.css';

export const CandleMagnitudeTargetHeader = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Target
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            % Of Pos.
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            {' '}
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
export const CandleMagnitudeStopHeader = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Stop
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            {' '}
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
